// Whether the box checkout is open over the podium on this phone
// (PodiumCheckout, opened from the scoreboard's Get my box).
//
// Two things wait on it:
// - GameWrapper holds this phone's move off the podium while it is open. The
//   GM's "Take everyone on" moves every phone still on the podium, and a
//   player half-way through the checkout would be pulled out of it: their
//   ticks lost, an order in flight never kept in this tab, and a second order
//   possible on the offer page. The moment the sheet closes (Done on a
//   confirmed order included) the phone follows the room; it is never held
//   anywhere but the podium.
// - FinalLeaderboard keeps the winner's pop-out (fixed, z 9999) from drawing
//   over the sheet.
//
// No React state of its own, so it costs the podium nothing until a checkout
// opens; components read it with usePodiumCheckoutOpen().
import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set();

export function setPodiumCheckoutOpen(isOpen) {
  const next = Boolean(isOpen);
  if (next === open) return;
  open = next;
  listeners.forEach((listener) => listener());
}

export function isPodiumCheckoutOpen() {
  return open;
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePodiumCheckoutOpen() {
  return useSyncExternalStore(subscribe, isPodiumCheckoutOpen, isPodiumCheckoutOpen);
}
